import { useMemo } from 'react';
import { useRemainingAmount } from '@ordering/stores/PaymentStore/hooks';
import { useTableOrder } from '@ordering/stores/TableOrderStore/hooks';
import { formatMinorToMajor } from '@ordering/utils/currency';
import { useLocale } from 'next-intl';

export const useFormattedRemainingAmount = () => {
  const locale = useLocale();
  const tableOrder = useTableOrder();
  const remainingAmount = useRemainingAmount(tableOrder.amount);

  return useMemo(
    () => formatMinorToMajor(remainingAmount, locale, tableOrder.currency),
    [remainingAmount, locale, tableOrder.currency]
  );
};
